import { Loadable } from '@/components/loaders';
import RouteConstants from '@/features/router/RouteConstants';
import { useWorkspace } from '@/features/workspaces/hooks';
import { PageLayout, PageListHeader } from '@/global/components';
import { IconButton } from '@/lib';
import { BreadcrumbItem } from '@/lib/Breadcrumbs';
import { useGetWorkspaceConnectorsQuery } from '@/services/endpoints/workspace-connectors';
import TargetIcon from '@assets/icons/target.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { DataCatalogDestinationGrid } from './DataCatalogDestinationGrid';
import { useCompanyValues } from '@/providers';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'ALL:destinations.title',
    path: RouteConstants.destinations,
  },
];

export const CatalogDestinationContent: FC = () => {
  const { id: workspaceId } = useWorkspace();
  const { currentLanguage } = useCompanyValues();
  const { data: customConnectors, isLoading: isCustomLoading } = useGetWorkspaceConnectorsQuery({ workspaceId, lang: currentLanguage });

  const { t } = useTranslation();
  const history = useHistory();

  const hasCustomConnectors = customConnectors && customConnectors.length > 0;

  console.log('customConnectors', customConnectors);

  return (
    <PageLayout>
      <PageListHeader breadcrumbs={breadcrumbs} title='ALL.destinations.catalogDestinations' subtitle='ALL.destinations.catalogDestinationsSubtitle'>
        <div className='flex gap-3'>
          {hasCustomConnectors && (
            <IconButton
              leadingIcon={<TargetIcon className='size-6 text-white-100' />}
              className='inline-flex w-full justify-center'
              onClick={() => history.push(RouteConstants.createCustomDestination)}
              text={t('ALL:destinations.audienceConnectAction')}
            />
          )}
        </div>
      </PageListHeader>

      <Loadable isLoading={isCustomLoading}>
        <DataCatalogDestinationGrid customConnectors={customConnectors} />
      </Loadable>
    </PageLayout>
  );
};
